import { render, staticRenderFns } from "./ComponentTextPersona.vue?vue&type=template&id=b4464690&"
import script from "./ComponentTextPersona.vue?vue&type=script&lang=js&"
export * from "./ComponentTextPersona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports